import { ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.UpAndRunningContainer = styled("div")(({ isDragging = false }) => ({
    position: 'relative',
    boxSizing: "border-box",
    borderRadius: 8,
    padding: 16,
    backgroundColor: ColorSAP.neutral[!isDragging ? 0 : 15],
    width: 365,
    height: !isDragging ? null : 'fit-content'
}));

Styled.DragAndDropPlaceholderText = styled("div")(() => ({
    width: '100%',
    paddingTop: 35,
    paddingBottom: 25,
    textAlign: 'center'
}));

Styled.TimelineInputContainer = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16
}));

Styled.FunctionBoxCollectionNoteActionsContainer = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    "& svg": {
        width: 24,
        height: 24,
    },
}));

Styled.FunctionCollectionNoteActionsContainer = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

Styled.NoteRendererContainer = styled("div")(() => ({
    marginTop: 16
}))

export default Styled;